import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {CpruMainComponent} from './components/cpru-main/cpru-main.component';

const routes: Routes = [
  {
    path: '**',
    component: CpruMainComponent,
    data: {layout: {narrowMainContainer: true}},
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Cpru2RoutingModule {}

export const cpru2RoutingComponents = [CpruMainComponent];
